import type { PokemonType } from './types'

export interface StarterOption {
  slug: string
  nameFr: string
  nameEn: string
  type: PokemonType
}

export interface RegionStarters {
  generation: number
  regionFr: string
  regionEn: string
  starters: [StarterOption, StarterOption, StarterOption]
}

export const REGION_STARTERS: RegionStarters[] = [
  {
    generation: 1,
    regionFr: 'Kanto',
    regionEn: 'Kanto',
    starters: [
      { slug: 'bulbasaur', nameFr: 'Bulbizarre', nameEn: 'Bulbasaur', type: 'grass' },
      { slug: 'charmander', nameFr: 'Salamèche', nameEn: 'Charmander', type: 'fire' },
      { slug: 'squirtle', nameFr: 'Carapuce', nameEn: 'Squirtle', type: 'water' },
    ],
  },
  {
    generation: 2,
    regionFr: 'Johto',
    regionEn: 'Johto',
    starters: [
      { slug: 'chikorita', nameFr: 'Germignon', nameEn: 'Chikorita', type: 'grass' },
      { slug: 'cyndaquil', nameFr: 'Héricendre', nameEn: 'Cyndaquil', type: 'fire' },
      { slug: 'totodile', nameFr: 'Kaiminus', nameEn: 'Totodile', type: 'water' },
    ],
  },
  {
    generation: 3,
    regionFr: 'Hoenn',
    regionEn: 'Hoenn',
    starters: [
      { slug: 'treecko', nameFr: 'Arcko', nameEn: 'Treecko', type: 'grass' },
      { slug: 'torchic', nameFr: 'Poussifeu', nameEn: 'Torchic', type: 'fire' },
      { slug: 'mudkip', nameFr: 'Gobou', nameEn: 'Mudkip', type: 'water' },
    ],
  },
  {
    generation: 4,
    regionFr: 'Sinnoh',
    regionEn: 'Sinnoh',
    starters: [
      { slug: 'turtwig', nameFr: 'Tortipouss', nameEn: 'Turtwig', type: 'grass' },
      { slug: 'chimchar', nameFr: 'Ouisticram', nameEn: 'Chimchar', type: 'fire' },
      { slug: 'piplup', nameFr: 'Tiplouf', nameEn: 'Piplup', type: 'water' },
    ],
  },
  {
    generation: 5,
    regionFr: 'Unys',
    regionEn: 'Unova',
    starters: [
      { slug: 'snivy', nameFr: 'Vipélierre', nameEn: 'Snivy', type: 'grass' },
      { slug: 'tepig', nameFr: 'Gruikui', nameEn: 'Tepig', type: 'fire' },
      { slug: 'oshawott', nameFr: 'Moustillon', nameEn: 'Oshawott', type: 'water' },
    ],
  },
  {
    generation: 6,
    regionFr: 'Kalos',
    regionEn: 'Kalos',
    starters: [
      { slug: 'chespin', nameFr: 'Marisson', nameEn: 'Chespin', type: 'grass' },
      { slug: 'fennekin', nameFr: 'Feunnec', nameEn: 'Fennekin', type: 'fire' },
      { slug: 'froakie', nameFr: 'Grenousse', nameEn: 'Froakie', type: 'water' },
    ],
  },
  {
    generation: 7,
    regionFr: 'Alola',
    regionEn: 'Alola',
    starters: [
      { slug: 'rowlet', nameFr: 'Brindibou', nameEn: 'Rowlet', type: 'grass' },
      { slug: 'litten', nameFr: 'Flamiaou', nameEn: 'Litten', type: 'fire' },
      { slug: 'popplio', nameFr: 'Otaquin', nameEn: 'Popplio', type: 'water' },
    ],
  },
  {
    generation: 8,
    regionFr: 'Galar',
    regionEn: 'Galar',
    starters: [
      { slug: 'grookey', nameFr: 'Ouistempo', nameEn: 'Grookey', type: 'grass' },
      { slug: 'scorbunny', nameFr: 'Flambino', nameEn: 'Scorbunny', type: 'fire' },
      { slug: 'sobble', nameFr: 'Larméléon', nameEn: 'Sobble', type: 'water' },
    ],
  },
  {
    generation: 9,
    regionFr: 'Paldea',
    regionEn: 'Paldea',
    starters: [
      { slug: 'sprigatito', nameFr: 'Poussacha', nameEn: 'Sprigatito', type: 'grass' },
      { slug: 'fuecoco', nameFr: 'Chochodile', nameEn: 'Fuecoco', type: 'fire' },
      { slug: 'quaxly', nameFr: 'Coiffeton', nameEn: 'Quaxly', type: 'water' },
    ],
  },
]

export function getStartersForGen(gen: number): RegionStarters | undefined {
  return REGION_STARTERS.find((r) => r.generation === gen)
}
